import { EOfferSpendByOfferScopeView } from '../../enum'

// Create a union type of all possible values from the enum
type IOfferSpendByOfferScopeViewLangKey = `${EOfferSpendByOfferScopeView}`

export type IOfferSpendByOfferScopeViewLang = {
	offer_spend_by_offer_scope_view: Record<IOfferSpendByOfferScopeViewLangKey, string>
}

const langEntries = Object.entries(EOfferSpendByOfferScopeView).map(
	([key, value]) => [value, `offer_spend_by_offer_scope_view.${value}`]
)

const langObj: Record<IOfferSpendByOfferScopeViewLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SPEND_BY_OFFER_SCOPE_VIEW_LANG_KEY: IOfferSpendByOfferScopeViewLang = {
	offer_spend_by_offer_scope_view: langObj
}
